{
  "header": "Documents",
  "noDocuments": "You don't have any documents",
  "noDocumentsFiltered": "No documents match your search criteria",
  "errorStateTitleDocuments": "Unable to load documents",
  "signed": "Signed",
  "notSigned": "Not Signed",
  "signedExternally": "Signed Externally",
  "headerTabs": {
    "html": "HTML",
    "pdf": "PDF"
  },
  "tabs": {
    "tableHeaders": {
      "date": "Date",
      "name": "Name",
      "frequency": "Frequency"
    },
    "statements": {
      "title": "Statements",
      "noDocuments": "You don't have any statements",
      "noDocumentsFiltered": "No statements match your search criteria",
      "errorStateTitleDocuments": "Unable to load statements"
    },
    "agreements": {
      "title": "Agreements",
      "noAgreements": "You currently have no signed agreements",
      "noAgreementsFiltered": "No agreements match your search criteria",
      "errorStateTitleAgreements": "Unable to load agreements",
      "uploadAgreement": "{{agreementName}} Upload"
    },
    "taxDocuments": {
      "title": "Tax Documents",
      "noDocuments": "You don't have any tax documents",
      "noDocumentsFiltered": "No tax documents match your search criteria",
      "errorStateTitleDocuments": "Unable to load tax documents"
    },
    "uploadedDocuments": {
      "title": "Uploaded Documents",
      "noDocuments": "You don't have any documents",
      "noDocumentsFiltered": "No documents match your search criteria",
      "errorStateTitleDocuments": "Unable to load documents",
      "documentUploadedSuccessfully": "Document uploaded successfully: {{fileName}}"
    },
    "tradeConfirmations": {
      "title": "Trade Confirmations",
      "noDocuments": "You don't have any trade confirmations",
      "noDocumentsFiltered": "No trade confirmations match your search criteria",
      "errorStateTitleDocuments": "Unable to load trade confirmations"
    },
    "clientReports": {
      "title": "Client Reports",
      "noClientReports": "You don't have any client reports",
      "noClientReportsFiltered": "No client reports match your search criteria",
      "errorStateTitleClientReports": "Unable to load client reports"
    },
    "formCompletions": {
      "title": "Forms"
    }
  },
  "button": {
    "uploadDocuments": "Upload documents",
    "uploadDocumentsMobile": "Upload",
    "uploadDocumentsEnhanced": "Add"
  },
  "addDocumentModal": {
    "title": "Upload documents",
    "subText": "You can upload any of these file types: .jpg, .csv, .jpeg, .pdf, or .png.",
    "selectFile": "Select a file",
    "inputLabel": "Document name",
    "inputPlaceholder": "Write the name of your document",
    "shareDocumentWithEveryone": "Share document with everyone",
    "grantAccessDocument": "Grant access to document to",
    "grantAccessDocumentError": "At least one role profile is required",
    "button": {
      "upload": "Upload",
      "cancel": "Cancel"
    },
    "tabs": {
      "statements": {
        "title": "Upload Statements"
      },
      "taxDocuments": {
        "title": "Upload Tax Documents"
      },
      "uploadedDocuments": {
        "title": "Upload Documents"
      },
      "tradeConfirmations": {
        "title": "Upload Trade Confirmations"
      }
    }
  },
  "filter": {
    "any": "Any",
    "button": {
      "applyFilters": "Apply",
      "resetFilters": "Reset all filters"
    },
    "date": "Time range",
    "account": "Accounts",
    "taxYear": "Tax year",
    "taxYearError": "Enter a valid 4-digit year between 1900 and {{currentYear}}",
    "placeholder": {
      "selectAccount": "Select an account"
    },
    "dateOptions": {
      "YEAR_TO_DATE": "Year to date",
      "MONTH_TO_DATE": "Month to date",
      "CUSTOM": "Custom"
    },
    "types": {
      "title": "Type",
      "accountStatements": {
        "MANAGEMENT_FEES_ANNUAL_REPORT": "Management Fees Annual Report",
        "ADMINISTRATIVE_FEES_ANNUAL_REPORT": "Administrative Fees Annual Report",
        "ANNUAL_PERFORMANCE_REPORT": "Annual Performance Report",
        "OV_MONTHLY_ACCOUNT_STATEMENTS": "OneVest Monthly Account Statements",
        "MONTHLY_ACCOUNT_STATEMENTS": "Monthly Account Statements",
        "ANNUAL_ACCOUNT_STATEMENTS": "Annual Account Statements",
        "QUARTERLY_ACCOUNT_STATEMENTS": "Quarterly Account Statements",
        "CONSOLIDATED_MONTHLY_ACCOUNT_STATEMENTS": "Consolidated Monthly Account Statements",
        "ACCOUNT_STATEMENT": "Account Statement",
        "TAX_SLIPS_LAST_10_MONTHS": "Tax Slips Last 10 Months",
        "TAX_SLIPS_FIRST_60_DAYS": "Tax Slips First 60 Days",
        "TAX_SLIPS_T4RSP_RL2": "Tax Slips T4RSP RL2",
        "TAX_SLIPS_T4RIF_RL2": "Tax Slips T4RIF RL2",
        "TAX_SLIPS_T4A_RL1": "Tax Slips T4A RL1",
        "TAX_SLIPS_NR4": "Tax Slips NR4",
        "TAX_SLIPS_T5008": "Tax Slips T5008",
        "TAX_SLIPS_TRADING_SUMMARY": "Tax Slips Trading Summary",
        "TAX_SLIPS_T5_RL3": "Tax Slips T5 RL3",
        "TAX_SLIPS_T3_RL16": "Tax Slips T3 RL16",
        "TAX_SLIPS_T3_BREAKDOWN": "Tax Slips T3 Breakdown",
        "TAX_SLIPS_T5013_RL15": "Tax Slips T5013 RL15",
        "TAX_SLIP_GENERAL": "Tax Slip General",
        "TAX_SLIPS_T4_FHSA": "Tax Slips T4 FHSA",
        "TAX_SLIPS_REST_OF_YEAR": "Tax Slips Rest of Year",
        "TAX_SLIPS_RL2": "Tax Slips RL2",
        "TAX_SLIPS_T3": "Tax Slips T3",
        "TAX_SLIPS_T5": "Tax Slips T5",
        "TAX_SLIPS_T4RIF": "Tax Slips T4RIF",
        "TAX_SLIPS_T4A": "Tax Slips T4A",
        "TAX_SLIPS_T4RSP": "Tax Slips T4RSP",
        "TRADE_CONFIRMATION": "Trade Confirmation"
      },
      "clientReports": {
        "ACCOUNT": "Account",
        "GOAL": "Goal",
        "SUB_ACCOUNT": "Sub-account",
        "CLIENT_GROUP": "Client Group",
        "INDIVIDUAL": "Individual",
        "NON_INDIVIDUAL": "Non-individual",
        "ACCOUNT_GROUP": "Account Group"
      }
    }
  },
  "droppableFileInput": {
    "dragFilesHere": "Drag & Drop a file here",
    "or": "or",
    "chooseAFile": "Browse a file",
    "clickToBrowse": "Drop file here or click to browse",
    "browse": "Browse",
    "chooseAnotherFile": "Choose another",
    "fileSize": "Document size",
    "maxDocumentSize": "Max document size: {{fileMaxSize}} MB",
    "max": "Max: {{fileMaxSize}} MB",
    "documentRequired": "Document attachment is required",
    "fileIsAboveMaxSize": "File size ({{size}}) is above maximum",
    "fileIsUnsupportedType": "Unsupported file type ({{type}}). Please use one of: {{acceptedTypes}}",
    "submit": "Upload"
  },
  "editDocumentModal": {
    "tabs": {
      "statements": {
        "title": "Edit statement",
        "documentName": "Statement name"
      },
      "taxDocuments": {
        "title": "Edit tax document",
        "documentName": "Tax Document name"
      },
      "uploadedDocuments": {
        "title": "Edit document",
        "documentName": "Document name"
      },
      "tradeConfirmations": {
        "title": "Edit trade confirmation",
        "documentName": "Trade Confirmation name"
      }
    }
  },
  "formCompletions": {
    "table": {
      "name": "Name",
      "package": "Package",
      "signedBy": "Signed by",
      "signedAt": "Signed at"
    }
  },
  "downloadDocuments": {
    "downloadedSuccessfully": "Documents downloaded successfully",
    "downloadedPartially": "Documents downloaded partially: {{successCount}} of {{totalFiles}}",
    "downloadFailed": "Failed to download documents"
  }
}
